import inRangeFile from "sounds/inRangeSound.mp3";
import outRangeFile from "sounds/outOfRangeSound.mp3";
import leftSpaceSoundFile from "sounds/leftSpaceSound.mp3";
import enterSpaceSoundFile from "sounds/enterSpaceSound.mp3";
import buzzSoundFile from "sounds/buzzSoundFile.mp3";
import newLiveChatSoundFile from "sounds/newLiveChatSound.mp3";
import focusCallSoundFile from "sounds/focusCallSound.mp3";
import unFocusCallSoundFile from "sounds/unFocusCallSound.mp3";

const BUZZ_TIME_INT = 2000;
var leftSpaceSound = null;
var enterSpaceSound = null;
var inRangeSound = null;
var outRangeSound = null;
var buzzSound = null;
var newLiveChatSound = null;
var focusCallSound = null;
var unFocusCallSound = null;
let unSafeSounds = {};

// THIS IS FOR YOU SAFARI!!!!

export function loadAudioSounds() {
  try {
    leftSpaceSound = new Audio();
    enterSpaceSound = new Audio();
    inRangeSound = new Audio();
    outRangeSound = new Audio();
    buzzSound = new Audio();
    newLiveChatSound = new Audio();
    focusCallSound = new Audio();
    unFocusCallSound = new Audio();
    inRangeSound.play();
    outRangeSound.play();
    leftSpaceSound.play();
    enterSpaceSound.play();
    buzzSound.play();
    newLiveChatSound.play();
    focusCallSound.play();
    unFocusCallSound.play();
  } catch (e) {
    window.log("Could not load Audio Sounds");
    window.log(JSON.stringify(e, null, 4));
  }
}

async function safePlaySound(soundObj, src) {
  if (unSafeSounds[src]) return;
  // soundObj.pause();
  try {
    // This is so safari actually plays sounds when no user interaction is made
    soundObj.src = src;
    unSafeSounds[src] = true;
    await soundObj.play();
    unSafeSounds[src] = false;
  } catch (e) {
    window.log("Error: Could not play sound");
  }
}

export const playInRangeSound = () => safePlaySound(inRangeSound, inRangeFile);
export const playOutRangeSound = () =>
  safePlaySound(outRangeSound, outRangeFile);
export const playEnterSpaceSound = () =>
  safePlaySound(enterSpaceSound, enterSpaceSoundFile);
export const playLeftSpaceSound = () =>
  safePlaySound(leftSpaceSound, leftSpaceSoundFile);
export const playNewLiveChatSound = () =>
  safePlaySound(newLiveChatSound, newLiveChatSoundFile);
export const playFocusCallSound = () =>
  safePlaySound(focusCallSound, focusCallSoundFile);
export const playUnFocusCallSound = () =>
  safePlaySound(unFocusCallSound, unFocusCallSoundFile);

let buzzingLuid = null;
let buzzes = 0;
let buzzInterval = null;
export function safePlayBuzzSound() {
  safePlaySound(buzzSound, buzzSoundFile);
}

export const playBuzzSound = (luid) => {
  if (buzzingLuid === luid) {
    buzzes++;
  } else {
    clearInterval(buzzInterval);
    buzzInterval = null;
    buzzingLuid = luid;
    buzzes = 1;
  }
  if (!buzzInterval) {
    safePlaySound(buzzSound, buzzSoundFile);
    buzzes--;
    buzzInterval = setInterval(() => {
      if (buzzes > 0) {
        safePlayBuzzSound();
        buzzes--;
      } else {
        clearInterval(buzzInterval);
        buzzInterval = null;
        buzzingLuid = null;
        buzzes = 0;
      }
    }, BUZZ_TIME_INT);
  }
};
export function stopBuzzSound() {
  clearInterval(buzzInterval);
  buzzInterval = null;
  buzzingLuid = null;
  buzzes = 0;
}
